<template>
    <div class="modal-header">
        <modal-title
            v-if="theme !== themes.EVENTRAC"
            :heading-text="headingText"
        ></modal-title>
        <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <modal-title
            v-if="theme === themes.EVENTRAC"
            :heading-text="headingText"
        ></modal-title>
    </div>
</template>

<script>
import TenantConfigurationThemes from '../../../../TenantConfigurations/consts/themes';
import ModalTitle from './ModalTitle.vue';

export default {
    name: 'ModalHeading',

    components: {
        ModalTitle,
    },

    props: {
        headingText: {
            required: true,
            type: String,
        },
        theme: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            themes: TenantConfigurationThemes,
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Bootstrap/BootstrapVersionFixers/ModalHeading/ModalHeading.vue